<template>
    <div class="vue-active-location-card" :class="{'active': active}">
        <span v-if="active" class="active-check"></span>

        <div class="row">
            <div class="info col">
                <p><span class="font-weight-bold">{{ location.name }}</span></p>

                <aut-pickup-point-selector
                    v-if="hasActiveLocation && hasPickupPoints"
                    @pickup-point="handlePickupPoint"
                    :location="getActiveLocation"
                ></aut-pickup-point-selector>

                <p v-if="!hasPickupPoints">{{ location.streetName }} {{ location.houseNumber }}, {{ location.postalCode }} {{ location.place }}</p>

                <aut-alert v-if="location.tempLocationWarning" :alert-text="location.tempWarningText"></aut-alert>
            </div>
        </div>
    </div>
</template>

<script>
import PickupPointSelector from "./PickupPointSelector.vue";
import {mapActions, mapGetters} from 'vuex';

export default {
    name: "ActiveCard",
    components: {
        'aut-pickup-point-selector': PickupPointSelector,
    },

    props: {
        location: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        ...mapGetters([
            'hasActiveLocation',
            'getActiveLocation',
        ]),

        hasPickupPoints() {
            return this.getActiveLocation.pickupPoints.length > 1;
        },

        computedDistance() {
            if (lodash.isEqual(this.location.distance, 0) || !this.location.distance) {
                return '';
            }

            const exactDistance = this.location.distance;
            let distanceRange = '< 100';

            if (exactDistance <= 10) {
                distanceRange = '< 10';
            }

            if (exactDistance > 10 && exactDistance <= 25) {
                distanceRange = '10-25';
            }

            if (exactDistance > 25 && exactDistance <= 50) {
                distanceRange = '26-50';
            }

            if (exactDistance > 50 && exactDistance <= 100) {
                distanceRange = '51-100';
            }

            if (exactDistance > 100) {
                distanceRange = '> 100';
            }

            return `${distanceRange} KM`;
        }
    },

    methods: {
        ...mapActions([
            'setActivePickupPoint'
        ]),

        handlePickupPoint(pickupPoint) {
            this.setActivePickupPoint(pickupPoint);
        },
    }
}
</script>